import { StateCreator } from 'zustand'
import { FilterValues, DraftsSlice, FilterStore } from './types'

const emptyDraft: FilterValues = {
  orgId: undefined,
  buildingId: undefined,
  // ADD HERE
}

export const createDraftsSlice: StateCreator<FilterStore, [], [], DraftsSlice> = (set, get) => ({
  draft: emptyDraft,

  setDraft(values) {
    set((state) => ({
      draft: {
        ...state.draft,
        ...values,
      },
    }))
  },

  resetDraft() {
    set({
      draft: {
        ...get().defaults,
      },
    })
  },

  resetDraftByKey(key: keyof FilterValues) {
    set({
      draft: {
        ...get().draft,
        [key]: get().defaults[key],
      },
    })
  },
})
